export const ACTION_SEQUENCE_STEP_TYPE = {
  USER_REGISTER: 'USER_REGISTER',
  USER_LOGIN: 'USER_LOGIN',
  USER_LOGOUT: 'USER_LOGOUT',
  USER_CHANGE_EMAIL_ADDRESS: 'USER_CHANGE_EMAIL_ADDRESS',
  USER_SEND_PASSWORD_RESET_LINK: 'USER_SEND_PASSWORD_RESET_LINK',
  USER_SEND_EMAIL_VERIFICATION_LINK: 'USER_SEND_EMAIL_VERIFICATION_LINK',
  USER_SEND_PHONE_VERIFICATION_CODE: 'USER_SEND_PHONE_VERIFICATION_CODE',
  USER_VERIFY_PHONE_VERIFICATION_CODE: 'USER_VERIFY_PHONE_VERIFICATION_CODE',
  USER_SEND_LOGIN_LINK: 'USER_SEND_LOGIN_LINK',
  NAVIGATE_TO_ROUTE: 'NAVIGATE_TO_ROUTE',
  NAVIGATE_TO_PAGE: 'NAVIGATE_TO_PAGE',
  NAVIGATE_TO_URL: 'NAVIGATE_TO_URL',
  NAVIGATE_BACK: 'NAVIGATE_BACK',
  DOCUMENT_CREATE: 'DOCUMENT_CREATE',
  DOCUMENT_UPDATE: 'DOCUMENT_UPDATE',
  DOCUMENT_DELETE: 'DOCUMENT_DELETE',
  DOCUMENT_SELECT: 'DOCUMENT_SELECT',
  DOCUMENT_DESELECT: 'DOCUMENT_DESELECT',
  MODAL_OPEN: 'MODAL_OPEN',
  MODAL_CLOSE: 'MODAL_CLOSE',
  ELEMENT_HIDE: 'ELEMENT_HIDE',
  ELEMENT_SHOW: 'ELEMENT_SHOW',
  ELEMENT_TOGGLE: 'ELEMENT_TOGGLE',
  SHOW_ALERT: 'SHOW_ALERT',
  SEQUENCE_EXIT: 'SEQUENCE_EXIT',
  SEQUENCE_START: 'SEQUENCE_START',
  SEARCH: 'SEARCH',
  SEARCH_NEXT_PAGE: 'SEARCH_NEXT_PAGE',
  SEARCH_PREVIOUS_PAGE: 'SEARCH_PREVIOUS_PAGE',
  RUN_AUTOMATION: 'AUTOMATION_START',
  JUMP_TO_ACTION_STEP: 'JUMP_TO_ACTION_STEP',
  GENERATE_PDF: 'GENERATE_PDF',
  LOCAL_STORE_VALUE_SET: 'LOCAL_STORE_VALUE_SET',
  LOCAL_STORE_SAVE_FORM: 'LOCAL_STORE_SAVE_FORM',
  LOCAL_STORE_VALUE_REMOVE: 'LOCAL_STORE_VALUE_REMOVE',
  LOCAL_STORE_VALUE_TOGGLE: 'LOCAL_STORE_VALUE_TOGGLE',
  EXECUTE_CODE: 'EXECUTE_CODE',
  CLOUD_FUNCTION: 'CLOUD_FUNCTION',
  VALIDATE_ELEMENT: 'VALIDATE_ELEMENT',
  VALIDATE_FORM: 'VALIDATE_FORM',
  STRIPE_CHECKOUT_SESSION: 'STRIPE_CHECKOUT_SESSION',
  STRIPE_CHARGE_UPSELLS: 'STRIPE_CHARGE_UPSELLS'
};
